import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useRouter } from "next/router";
import { capitalize } from "helpers/algoliaUtils";
import { SubcategoriesStaticData } from "data/categories";

export default function Breadcrumb({ items, refine }) {
  const router = useRouter();
  return (
    <Box pt={2}>
      <Typography onClick={() => router.push("/reconditionne/")} variant="caption" style={{ cursor: "pointer" }}>
        Accueil
      </Typography>

      {Boolean(items?.length) &&
        items.map((item) => (
          <Typography key={item.value} variant="caption">
            &nbsp;&gt;&nbsp;
            <span
              role="button"
              onKeyDown={() => {}}
              tabIndex={0}
              onClick={(event) => {
                event.preventDefault();
                refine(item.value);
              }}
              style={{ cursor: "pointer" }}
            >
              {SubcategoriesStaticData.find((cat) => cat.slug === item.label)?.name || capitalize(item.label)}
            </span>
          </Typography>
        ))}
    </Box>
  );
}
